import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getFileSizeDisplay, Localization } from '@sphereon/ui-components.core';
import ComboBox from '../ComboBox';
import DocumentIcon from '../../assets/icons/DocumentIcon';
import ImageIcon from '../../assets/icons/ImageIcon';
import CrossIcon from '../../assets/icons/CrossIcon';
import { FileSelectionFieldContainerStyled as Container, FileSelectionFieldContentContainerStyled as ContentContainer, FileSelectionFieldRemoveContainerStyled as RemoveContainer, FileSelectionFieldRemoveButtonStyled as RemoveButton, FileSelectionFieldRemoveButtonCircleIconStyled as RemoveButtonCircleIcon, FileSelectionFieldIconContainerStyled as IconContainer, FileSelectionFieldFileDataContainerStyled as FileDataContainer, FileSelectionFieldFileNameCaptionStyled as FileNameCaption, FileSelectionFieldFileSizeCaptionStyled as FileSizeCaption, FileSelectionFieldPermissionSelectionContainerStyled as PermissionSelectionContainer, } from '../../../styles';
import { FileSelectionFieldType } from '../../../types';
const filePermissions = [
    { label: Localization.translate('file_permission_public_label'), value: 'public' },
    { label: Localization.translate('file_permission_private_label'), value: 'private' },
];
const FileSelection = (props) => {
    const { file, fileType = FileSelectionFieldType.FILE, permission, onPermissionChange, onRemove, style } = props;
    const onChange = async (selection) => {
        if (onPermissionChange) {
            await onPermissionChange(selection.value);
        }
    };
    return (_jsxs(Container, { style: style, children: [_jsxs(ContentContainer, { children: [_jsx(IconContainer, { children: getIcon(fileType) }), _jsxs(FileDataContainer, { children: [_jsx(FileNameCaption, { children: file.name }), file.size && _jsx(FileSizeCaption, { children: getFileSizeDisplay(file.size) })] }), permission && (_jsx(PermissionSelectionContainer, { children: _jsx(ComboBox, { style: { width: 152, marginLeft: 'auto' }, defaultValue: filePermissions.find((selection) => selection.value === permission), onChange: onChange, options: filePermissions }) }))] }), onRemove && (_jsx(RemoveContainer, { children: _jsx(RemoveButton, { onClick: onRemove, children: _jsx(RemoveButtonCircleIcon, { children: _jsx(CrossIcon, { size: 10 }) }) }) }))] }));
};
const getIcon = (fileType) => {
    switch (fileType) {
        case FileSelectionFieldType.FILE:
            return _jsx(DocumentIcon, {});
        case FileSelectionFieldType.IMAGE:
            return _jsx(ImageIcon, {});
        default:
            return _jsx("div", {});
    }
};
export default FileSelection;
